export default __webpack_public_path__ + "306a706e38063071ead41d605d01f2dc.jpg";